import React from "react";
import {withStyles} from "@material-ui/core/styles";
import MaskedInput from "react-text-mask/dist/reactTextMask";

const FormFieldMask = props => {

    const { inputRef, type, classes, ...other } = props;

    let mask = [''];
    switch(type){
        case 'iban':
            mask = [
                /[a-zA-Z]/,/[a-zA-Z]/, /\d/, /\d/,' ',
                /\d/, /\d/, /\d/, /\d/, ' ',
                /\d/, /\d/, /\d/, /\d/, ' ',
                /\d/, /\d/, /\d/, /\d/, ' ',
                /\d/, /\d/, /\d/, /\d/, ' ',
                /\d/, /\d/, /\d/, /\d/, ' ',
                /\d/, /\d/, /\d/, /\d/, ' ',
                /\d/, /\d/, /\d/, /\d/, ' ',
                /\d/, /\d/, /\d/, /\d/, ' ',
            ];
            break;
        case'bic':
            mask = [
                /[a-zA-Z]/,/[a-zA-Z]/,/[a-zA-Z]/,/[a-zA-Z]/,    // BBBB
                /[a-zA-Z]/,/[a-zA-Z]/,                          // CC
                /[0-9a-zA-Z]/,/[0-9a-zA-Z]/,
                /[0-9a-zA-Z]/,/[0-9a-zA-Z]/,/[0-9a-zA-Z]/
            ];
            break;
    }

    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={mask}
            placeholderChar={'\u2000'}
            //showMask
            guide={false}
        />
    );
}

const styles = theme => ({

});

export default withStyles(styles)(FormFieldMask);
